import { Box, Container, Stack, Typography } from "@mui/material";
import React from "react";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import sendingEmail from "../../assets/images/handy-mailbox-sends-mail.png";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

function Thanks() {
  return (
    <Container>
      <Stack>
        <Item
          style={{ display: "flex", marginTop: "50px" }}
          sx={{ flexDirection: { xs: "column", sm: "row" } }}
        >
          <Box style={{ flex: 1, textAlign: "center" }}>
            <h1>
              <CheckCircleIcon color="success" /> Thank you for contacting me
            </h1>
            <Typography variant="body1" gutterBottom>
              Your email has sent succssefully. I will reply to you as soon as
              possible.
            </Typography>
          </Box>
          <Box>
            <img src={sendingEmail} width="200" />
          </Box>
        </Item>
      </Stack>
    </Container>
  );
}

export default Thanks;
